import { timeout, delay } from '@ynap/promise-utils'
import { ResponseError, Reservations } from '@ynap/api-utils'
import {
    FETCH_RESERVATIONS_REQUEST,
    FETCH_RESERVATIONS_SUCCESS,
    FETCH_RESERVATIONS_ERROR,
} from '../constants/ActionTypes'
import { redirectToLogin } from '@ynap/redirect-utils'

function fetchReservationsRequest() {
    return {
        type: FETCH_RESERVATIONS_REQUEST,
    }
}

function fetchReservationsSuccess(reservations) {
    return {
        type: FETCH_RESERVATIONS_SUCCESS,
        reservations,
    }
}

function fetchReservationsError() {
    return {
        type: FETCH_RESERVATIONS_ERROR,
    }
}

export default function fetchReservations() {
    return (dispatch, getState, fetch) => {
        const { locale, config = {}, uberToken } = getState()
        const { langId, country } = locale
        const { clientRequest } = config.head || config
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce
        const { brandId } = config.watsonService || config.global.application

        if (!uberToken) {
            return redirectToLogin(locale.id)
        }

        dispatch(fetchReservationsRequest())

        const request = Reservations.getReservations({
            baseUrl,
            brandId,
            country,
            uberToken,
            clientId,
            clientSecret,
            langId,
        })

        //todo look at if this is shareable across state packages
        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((res) => {
                const { ok, status } = res
                if (ok) {
                    return res.json().then((json) => dispatch(fetchReservationsSuccess(json)))
                } else if (status === 401 || status === 403) {
                    return redirectToLogin(locale.id)
                }
                throw new ResponseError(res)
            })
            .catch((error) => {
                dispatch(fetchReservationsError())
                throw error
            })
    }
}
